export enum ManageDeviceActionTypes {
  GET_MANAGE_DEVICE_DETAILS = 'GET_MANAGE_DEVICE_DETAILS',
  UPDATE_MANAGE_DEVICES_DETAILS = 'UPDATE_MANAGE_DEVICES_DETAILS',
  MANAGE_DEVICES_STATUS = 'MANAGE_DEVICES_STATUS',
  SIGNINGOUT_DEVICE = 'SIGNINGOUT_DEVICE',
  UPDATE_SIGNOUT_DEVICE_DETAILS = 'UPDATE_SIGNOUT_DEVICE_DETAILS',
  RESET_SIGNOUT_DEVICE = 'RESET_SIGNOUT_DEVICE',
}
